<script>
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";
    import {mapState} from "vuex";

    export default {
        name: "AffiliatesRegistrationElement",
        mixins: [
            AnimationsMixin,
        ],
        data() {
            return {
                elementType: 'affiliates-registration',
                givesContextToChildren: true
            }
        },
        computed: {
            states(){
                return[
                    'logged-out',
                    'logged-in'
                ];
            }
        },
        mounted(){
            this.translateElements();
        },
        methods: {
            changeView(val){
                this.states.forEach(status => {
                    this.elementNode.classList.remove(`form-${status}`);
                });
                this.elementNode.classList.add(`form-${val}`);
            },
            translateElements () {
                // gdpr checkbox label
                const checkboxLabel1 = this.myNode.querySelector('.js-translate-i_accept_the');
                const checkboxLabel2 = this.myNode.querySelector('.js-translate-affiliate_program_terms');
                if (checkboxLabel1) {
                    checkboxLabel1.innerText = this.$t('affiliates.i_accept_the');
                }

                if (checkboxLabel2) {
                    checkboxLabel2.innerText = this.$t('affiliates.affiliate_program_terms');
                }
            },
        },
        watch: {

        }
    }
</script>
